<!-- 由 suu 创建于 2021-07-07 星期三 -->
<template>
  <div class="heat-info" v-if="info">
    <!-- 标题栏 -->
    <div class="hi-title">
      <div class="t-left">热量</div>
      <div class="t-right">
        <div
          class="r-item"
          :class="{ 'r-item-ac': curType == 0 }"
          @click="changeType(0)"
        >
          千卡
        </div>
        <div
          class="r-item"
          :class="{ 'r-item-ac': curType == 1 }"
          @click="changeType(1)"
        >
          千焦
        </div>
      </div>
    </div>
    <!-- 信息 -->
    <div class="hi-num" v-if="curType == 1">{{ info.J }}<span>千焦</span></div>
    <div class="hi-num" v-else>{{ info.cal }}<span>千卡</span></div>
    <div class="hi-tips">每{{ info.weight }}克（可食用部分）</div>
    <!-- 范围条 -->
    <div class="hi-range">
      <div class="r-cur" :style="{ left: rangeRate }"></div>
      <div class="r-item r-item-1">
        <span>相对较低</span>
      </div>
      <div class="r-item r-item-2">
        <span>相对一般</span>
      </div>
      <div class="r-item r-item-3">
        <span>相对较高</span>
      </div>
    </div>
    <!-- <div class="hi-rate">
      热量低于<span :style="{ color: rateColor }">{{ info.cal_rank }}</span
      >的{{ info.cal_rank_type }}
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'heat-info',

  components: {},

  props: {
    info: {}
  },

  data() {
    return {
      curType: 0,
      rangeList: [
        {
          min: 0,
          max: 120
        },
        {
          min: 121,
          max: 260
        },
        {
          min: 261,
          max: 929
        }
      ]
    }
  },

  computed: {
    // 计算比例颜色
    rateColor() {
      const rate = parseInt(this.info.cal_rank)
      if (rate < 60) {
        return '#49ceba'
      } else if (rate < 80) {
        return '#ffe18d'
      } else {
        return '#ff4949'
      }
    },
    // 计算范围
    rangeRate() {
      const cur = this.info.cal
      let curIndex
      this.rangeList.map((item, index) => {
        if (cur >= item.min && cur <= item.max) {
          curIndex = index
        }
      })
      let res
      if (curIndex === undefined) {
        res = cur < this.rangeList[0].min ? 0 : 100
      } else {
        let everyItem = 100 / this.rangeList.length
        res =
          curIndex * everyItem +
          everyItem *
            ((cur - this.rangeList[curIndex].min) /
              (this.rangeList[curIndex].max - this.rangeList[curIndex].min))
      }
      return res + '%'
    }
  },

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {
    changeType(i) {
      this.curType = i
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.heat-info {
  width: 91.5vw;
  box-sizing: border-box;
  padding: 3.7vw 4.3vw 12vw;
  background-color: #ffffff;
  border-radius: 2.7vw;
  margin-top: 4.3vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  .hi-title {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .t-left {
      font-size: 4vw;
      font-weight: 600;
      color: #000;
    }
    .t-right {
      width: 22.7vw;
      height: 5.3vw;
      background-color: #f1f1f1;
      border-radius: 1.1vw;
      display: flex;
      align-items: center;
      .r-item {
        width: 50%;
        height: 5.3vw;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 2.7vw;
        color: #000;
      }
      .r-item-ac {
        font-weight: 600;
        height: 6.4vw;
        background-color: #ffffff;
        box-shadow: 0vw 0.3vw 0.8vw 0vw rgba(0, 0, 0, 0.05);
        border-radius: 1.1vw;
        border: solid 0.3vw #dddddd;
      }
    }
  }
  .hi-num {
    margin-top: 3.7vw;
    font-size: 12.8vw;
    color: #3b4761;
    span {
      font-size: 3.2vw;
    }
  }
  .hi-tips {
    font-size: 3.2vw;
    color: rgba(0, 0, 0, 0.7);
    margin-top: -0.5vw;
  }
  .hi-range {
    width: 70.7vw;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    margin-top: 10.1vw;
    position: relative;
    .r-item {
      width: 22.7vw;
      height: 1.9vw;
      background-color: #49ceba;
      border-radius: 1.1vw;
      position: relative;
      span {
        width: max-content;
        position: absolute;
        top: 6vw;
        left: 50%;
        transform: translateX(-50%);
        font-size: 3.2vw;
        color: rgba(0, 0, 0, 0.5);
      }
    }
    .r-item + .r-item {
      margin-left: 1.3vw;
    }
    .r-item-2 {
      background-image: linear-gradient(90deg, #49ceba 0%, #ffe18d 100%);
    }
    .r-item-3 {
      background-image: linear-gradient(90deg, #ffe18d 0%, #ff4949 100%);
    }
    .r-cur {
      width: 1.7vw;
      height: 1.7vw;
      background-color: #fff;
      border-radius: 50%;
      border: 1vw solid #000;
      position: absolute;
      z-index: 9;
      left: 0;
      top: 50%;
      transform: translate(-50%, -50%);
      transition: linear 0.5s all;
    }
  }
  .hi-rate {
    font-size: 3.2vw;
    margin-top: 17.3vw;
    span {
      font-weight: 600;
      color: #49ceba;
    }
  }
}
</style>
